<template>
  <Modal :open="open" @close="closeModal">
    <div>
      <div class="text-center">
        <h2 class="text-lg font-semibold text-gray-900">Nouvelle activité</h2>
      </div>

      <div class="mb-6">
        <Selector
          id="noteType"
          name="noteType"
          v-model="newNote.noteType"
          label="Type de note"
          label-class="block text-sm font-medium leading-6 text-gray-900"
          :options="noteTypesOptions"
          :required="true"
        />
      </div>

      <div class="mb-6">
        <FormField
          id="content"
          name="content"
          v-model="newNote.content"
          label="Contenu de la note"
          label-class="block text-sm font-medium leading-6 text-gray-900"
          :required="true"
        />
      </div>

      <div class="flex justify-center space-x-4">
        <SecondaryButton @click="closeModal">Annuler</SecondaryButton>
        <GenericButton @click="createNote">Créer</GenericButton>
      </div>
    </div>
  </Modal>
</template>

<script>
import { Modal, SecondaryButton, FormField, Selector, GenericButton } from "@estaly/ui";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "StoreEventNoteCreateModal",

  components: {
    GenericButton,
    Modal,
    SecondaryButton,
    FormField,
    Selector,
  },

  props: {
    open: {
      type: Boolean,
      default: false,
    },
    store: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      newNote: {
        content: "",
        noteType: null,
      },
    };
  },

  computed: {
    ...mapGetters("storeEventNotes", ["noteTypes"]),

    noteTypesOptions() {
      return this.noteTypes().map((noteType) => ({
        value: noteType,
        label: this.$t(`storeEventNote.noteType.${noteType}`),
      }));
    },
  },

  methods: {
    ...mapActions("notifications", ["notify"]),
    ...mapActions("storeEventNotes", ["create"]),

    closeModal() {
      this.newNote.content = "";
      this.newNote.noteType = null;
      this.$emit("close");
    },

    async createNote() {
      if (!this.newNote.content.trim()) {
        await this.notify({
          category: "simple",
          type: "error",
          title: "Le contenu de la note est requis",
        });
        return;
      }

      const response = await this.create({
        storeId: this.store.id,
        content: this.newNote.content,
        noteType: this.newNote.noteType,
      });

      if (response?.success) {
        await this.notify({
          category: "simple",
          type: "success",
          title: "Note créée avec succès",
        });
      }

      this.$emit("addedNote");
      this.closeModal();
    },
  },
};
</script>
